export function injectWKWebViewConsoleBridge() {
  if (typeof window === 'undefined' || typeof window.console === 'undefined') {
    return;
  }

  if (window.console._wkwebviewOverrided) return;

  const oldLog = console.log;

  console.log = function (...args) {
    oldLog.apply(console, args);

    // WKWebView 환경에서만 브릿지 호출
    if (
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.jsConsole
    ) {
      try {
        const msg = args
          .map((v) =>
            typeof v === 'object' ? JSON.stringify(v, null, 2) : String(v),
          )
          .join(' ');

        window.webkit.messageHandlers.jsConsole.postMessage({ msg });
      } catch (e) {
        // ignore error (ex: cyclic object)
      }
    }
  };

  window.console._wkwebviewOverrided = true;
}
